import {loadScript, loadStyle} from './modules/loadAsset'

class ResourceLoader {

    constructor() {
        this.tags = []
    }

    checkIfResourceExist(plugin, type) {
        if (type === 'css') {
            const linkElement = document.querySelectorAll(`link[href="${plugin.style}"]`)
            return linkElement.length >= 1
        } else if (type === 'js') {

            if (this.tags.length === 0) {
                const scriptTags = document.getElementsByTagName('script')
                return Array.prototype.filter.call(scriptTags, (tag) => {
                    return tag.getAttribute('src') === plugin.url
                }).length >= 1
            }
            return this.tags.filter((t) => {
                return t.url === plugin.url
            }).length >= 1
        }
    }

    /**
     * Appends a element to DOM
     *
     * @param plugin
     * @param type
     * @returns {Promise<>}
     */
    load(plugin, type) {

        // Check is resource link exists
        if (this.checkIfResourceExist(plugin, type)) {
            return Promise.resolve()
        }

        this.tags = [...this.tags, {url: plugin.url, style: plugin.style}]

        if (type === 'js') {
            return loadScript(plugin)
        } else if (type === 'css') {
            return loadStyle(plugin)
        } else {
            return Promise.reject('Tried to load invalid type' + type)
        }
    }
}

export default ResourceLoader
